<template>
  <a class="timeline-container" >
    <span class="year">{{year}}</span>
    <div class="timeline" v-on:mouseleave="isMouseOver=false">
      <transition :name="fadeTransition" mode="out-in">
        <div class="timeline-reduced" v-if="!isFull" key="1">
          <div class="timeline-reduced-bar-container" v-on:mouseover="isMouseOver=true">
            <div class="timeline-reduced-bar">
              <div v-bind:style="barH"></div>
            </div>
          </div>
          <div class="panel">
            <div v-on:click="togglePlayPause">
              <button class="playpause-toggle" v-bind:class="{'pause':playing, 'off':!playing}"></button>
              <span v-if="!playing" class="desktop keep">Play</span>
              <span v-else lass="desktop" class="desktop">Pause</span>
            </div>
            <div v-on:click="toggleDayNight" class="desktop">
              <button class="daynight-toggle" v-bind:class="{'off':!nightMode}"></button>
              <span>Night mode</span>
            </div>
            <div  v-on:click="toggleFerries" class="desktop">
              <button class="ferries-toggle" v-bind:class="{'off':!ferriesVisible}"></button>
              <span>Ferries</span>
            </div>
            <div v-on:click="toggleLabels" class="desktop">
              <button class="labels-toggle" v-bind:class="{'off':!labelsVisible}"></button>
              <span>Cities</span>
            </div>
          </div>
        </div>



        <div class="timeline-full" key="2" v-else v-on:mouseover="isMouseOver=true">
          <div v-on:mouseleave="hoverIndex=-1" class="timeline-tiles">
            <div class="timeline-tile" @click="onTileClick(i)" v-for="i in 101" v-bind:key="i" v-on:mouseover="hoverIndex=i" v-bind:style="tiles[i].style"  v-bind:class="{'tile-hover':i==highlightIndex}"></div>
          </div>
          <div class="timeline-tile-info">
            <span style="top:0px;line-height:0.6;" v-if="hoverIndex!=0">1920</span>
            <div style="line-height:0.6; color:#FF6063" v-if="hoverIndex>=0" v-bind:style="{top:hoverIndex-1+'%'}"><span style="display:block;">{{1920+hoverIndex-1}}</span><span style="line-height:1.2; padding-top:0.4rem; display:block;">{{tiles[hoverIndex].title}}</span> </div>
            <span style="top:100%;line-height:0.5;" v-if="hoverIndex<94">2020</span>
          </div>
        </div>
      </transition>
    </div>
    <a target="_blank" href="http://www.vam.ac.uk/" class="desktop"><img class="logo" src="@/assets/icons/logo-VAM.svg" /></a>

  </a>
</template>
<script>
// @ is an alias to /src
import { mapGetters } from 'vuex'

export default {
  name: 'timeline',
  components: {

  },
  watch: {

  },
  computed:{
    ...mapGetters(['facts', 'detailedView', 'playing', 'nightMode', 'ferriesVisible', 'labelsVisible',  'isMobile']),
    fadeTransition: function(){
      if(this.timelineAppeared)
        return 'timeline-fade'
      return 'component-fade'
    },
    alpha: {
      get() { return this.$store.state.alpha; },
      set(d) { this.$store.commit('setAlpha', d); },
    },
    timelineAppeared: {
      get() { return this.$store.state.timelineAppeared; },
      set(d) { this.$store.commit('setTimelineAppeared', d); },
    },
    year: {
      get() { return this.$store.state.year; },
      set(d) { this.$store.commit('setYear', d); },
    },
    resetScroll: {
      get() { return this.$store.state.resetScroll; },
      set(f) { this.$store.commit('setResetScroll', f); },
    },
    barH: function(){
      return {height:(this.alpha*100)+'%'};
    },
    highlightIndex: function(){
      if(this.hoverIndex>=0) return this.hoverIndex;
      return this.year-1920;
    },
    isFull: function(){
      return this.isMouseOver || this.initialFade;
    }
  },
  data() {
    return {
      isMouseOver:false,
      tiles:[],
      hoverIndex: -1,
      initialFade: false
    }
  },
  methods: {
    onTileClick: function (i) {
      this.year = 1919 + i;
      this.resetScroll = true;
      this.$store.commit('setNeedsRender', true);
    },

    toggleLabels: function () {
      this.$store.commit('setLabelsVisible', !this.labelsVisible);
    },
    toggleFerries: function () {
      this.$store.commit('setFerriesVisible', !this.ferriesVisible);
    },
    togglePlayPause: function () {
      if(!this.playing && this.alpha == 1){
        this.alpha = 0
      }
      this.$store.commit('setPlaying', !this.playing);

    },
    toggleDayNight: function () {
      this.$store.commit('setNightMode', !this.nightMode);
    },
  },
  mounted: function(){

  },
  created: function(){
    var fIndex = 1;
    for (var i = 0; i <= 101; i++) {
      const year = 1920+i-1;
      let style = {
        background: '#677677'
      }
      let title = '';
      if(this.facts[fIndex].year == year){
        title = this.facts[fIndex].title;
        fIndex = Math.min(this.facts.length-1, fIndex+1);
        style['background'] = 'rgba(132,95,99,1)'
      }
      if(i<100 && i>0 && i%10==0)
      style['border-bottom'] = '1px solid white';
      this.tiles.push({style:style, title:title});
    }
    if(!this.timelineAppeared && !this.isMobile){
      this.initialFade =true;
      setTimeout(()=>{
        this.initialFade =false;
        setTimeout(()=>{
          this.timelineAppeared=true;
        }, 1000);
      }, 3000);
    }
  }
}
</script>
<style lang="scss">

.timeline-container{
  position:fixed;
  top:0px;
  left:0px;
  height:100%;
  padding-left:1.63rem;
  box-sizing: border-box;
  padding-bottom: 1.63rem;
  padding-top: 4.47rem;
  display: flex;
  flex-direction: column;
  z-index:4;
  .year{
    font-size: 2.86rem;
    font-family: Formular-Mono;
    color: #FF6063;
    display:block;
  }
  .timeline{
    flex-grow:1;
    margin-top:1.38rem;
    margin-bottom: 2.48rem;
    margin-left:0.52rem;
    display: flex;
  }

  .timeline-full{
    display: inline-flex;
    font-size:0.85rem;
    font-weight: lighter;
  }

  .timeline-reduced{
    min-width: 10px;
  }
  .timeline-reduced-bar{
    background:white;
    width:0.5rem;
    height: 100%;
  }
  .timeline-reduced-bar div{
    background:rgb(255, 96, 99);
  }
}







.timeline-full> div{
  display:table-column;
  height:100%;
  position: relative;
}
.timeline-tile-info{
  width: 2.5rem;
  overflow:visible;
}
.timeline-tile-info >*{
  padding-left:0.7rem;
  position:absolute;
  width:10.2rem;
}

.timeline-tiles{
  border-top:1px solid #aaa;
}
.timeline-tile{
  width:1.63rem;
  height:1%;
  display:block;
  border: 1px solid #aaa;
  border-top: none;
  box-sizing: border-box;
}

.tile-hover{
  background: #FF6063 !important;
}

.timeline-reduced{
  display:flex;

}
.timeline-reduced-bar-container{
  padding-right:1rem;
}

.timeline-reduced .panel{
  margin-left:0.42rem;

}

.timeline-reduced .panel >div{
  display:flex;
  color:transparent;
  font-size:0.85rem;
  font-weight: lighter;
  line-height: 1.42rem;
}
.timeline-reduced span.keep {
  color:white!important;
}
.timeline-reduced .panel >div:hover {
  color:white;
  button{
    opacity:1!important;
  }
}
.timeline-reduced .panel button{
  margin-right:0.71rem;
}

.timeline-reduced .panel button{
  width:1.42rem;
  height:1.42rem;
  border-radius: 0.71rem;
  display:block;
  margin-bottom:0.71rem;
}

.timeline-reduced .panel button.playpause-toggle{
  background: url(../assets/icons/play.svg);
  margin-bottom:1.42rem;
}

.timeline-reduced .panel button.playpause-toggle.pause{
  background: url(../assets/icons/pause.svg);

}

.daynight-toggle{
  background: url(../assets/icons/night.svg);

}

.ferries-toggle{
  background: url(../assets/icons/ferries.svg);
}

.labels-toggle{
  background: url(../assets/icons/labels.svg);
}

.off{
  opacity:0.4;
}



.timeline-fade-enter-active{
  transition: opacity 0.5s;
}
.timeline-fade-leave-active, .timeline-fade-enter, .timeline-fade-leave-to{
  opacity: 0.0;
}

.component-fade-enter-active, .component-fade-leave-active {
  transition: opacity 1.0s ease;
}
.component-fade-enter, .component-fade-leave-to
/* .component-fade-leave-active below version 2.1.8 */ {
opacity: 0;
}

.timeline >*{
  display:flex;
}


</style>
